"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mdDateTimePicker_1 = require("./md-date-time-picker/js/mdDateTimePicker");
var omi_1 = require("omi");
var css = require("./index.scss");
var moment = require("moment");
//@ts-ignore
require("../theme.ts");
var DateTimePicker = /** @class */ (function (_super) {
    __extends(DateTimePicker, _super);
    function DateTimePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateTimePicker.prototype.install = function () {
        moment.locale(this.props.lan);
    };
    DateTimePicker.prototype.receiveProps = function (props, pre) {
        if (props.show && !pre.show) {
            this.picker.show();
        }
        else if (pre.show && !props.show) {
            this.picker.hide();
        }
        return false;
    };
    DateTimePicker.prototype.installed = function () {
        var _this = this;
        var now = moment();
        //@ts-ignore
        var picker = new mdDateTimePicker_1.default({
            type: this.props.type,
            root: this.shadowRoot.querySelector('.m-m-date-time-picker'),
            init: this.props.init ? moment(this.props.init) : now,
            past: this.props.past ? moment(this.props.past) : moment().subtract(21, 'years'),
            future: this.props.future ? moment(this.props.future) : now,
            onOk: function (evt) {
                _this.fire('ok', evt);
            },
            onCancel: function () {
                _this.fire('cancel');
            }
        });
        if (this.props.show) {
            picker.show();
        }
        this.picker = picker;
    };
    DateTimePicker.prototype.render = function (props) {
        return (omi_1.h("div", __assign({}, omi_1.extractClass(props, 'm-m-date-time-picker'))));
    };
    DateTimePicker.css = css;
    DateTimePicker.defaultProps = {
        type: 'date',
        show: false
    };
    DateTimePicker.propTypes = {
        type: String,
        show: Boolean,
        init: String,
        past: String,
        future: String,
        lan: String
    };
    DateTimePicker = __decorate([
        omi_1.tag('m-date-time-picker')
    ], DateTimePicker);
    return DateTimePicker;
}(omi_1.WeElement));
exports.default = DateTimePicker;
